import { render, staticRenderFns } from "./LabelWithValue.vue?vue&type=template&id=35888a67&scoped=true&"
import script from "./LabelWithValue.vue?vue&type=script&lang=ts&"
export * from "./LabelWithValue.vue?vue&type=script&lang=ts&"
import style0 from "./LabelWithValue.vue?vue&type=style&index=0&id=35888a67&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35888a67",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35888a67')) {
      api.createRecord('35888a67', component.options)
    } else {
      api.reload('35888a67', component.options)
    }
    module.hot.accept("./LabelWithValue.vue?vue&type=template&id=35888a67&scoped=true&", function () {
      api.rerender('35888a67', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LabelWithValue.vue"
export default component.exports